module.exports = __webpack_public_path__ + "static/media/icn-at.a0ddfa06.svg";